import { NO_ALTERNATE_PAGES_INCLUDES } from '$lib/constants/noAlternatePages'

export function hasAlternate(pathname: string) {
  return !NO_ALTERNATE_PAGES_INCLUDES.some((alternatePath) =>
    pathname.includes(alternatePath),
  )
}
